module.exports = __webpack_public_path__ + "img/jack-hodgkin.b9c86b76.jpg";